import * as React from 'react';
import { FC } from 'react';

import { Box } from '@rbilabs/universal-components';

import { ISanityTextNode } from '@rbi-ctg/menu';
import LoadingAnimation from 'components/loading-animation';
import { ResponsiveCarousel } from 'components/responsive-carousel';

import { QuestsTitle, StyledQuestCard } from './loyalty-quests-widget.styled';
import { useQuests } from './use-quests';

export const LoyaltyQuestsWidget: FC<React.PropsWithChildren<{ title?: ISanityTextNode }>> = ({
  title,
}) => {
  const { data: quests, loading } = useQuests();

  if (loading) {
    return <LoadingAnimation />;
  }

  return (
    <Box
      // @ts-ignore section is not a valid native role, but on web it is.
      accessibilityRole="section"
    >
      {title?.locale && <QuestsTitle>{title?.locale}</QuestsTitle>}
      <ResponsiveCarousel
        data={quests}
        keyExtractor={(item, index) => item?.title?.locale || index}
        renderItem={({ item, index }) => (
          <StyledQuestCard $fadeDelayMultiplier={index} quest={item} />
        )}
      />
    </Box>
  );
};
